"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeMorning = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const TimeMorning = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("mask", { id: "mask0", maskUnits: "userSpaceOnUse", x: "1", y: "2", width: "14", height: "8" },
        react_1.default.createElement("rect", { x: "1", y: "2", width: "14", height: "8", fill: "#B5C2CA" })),
    react_1.default.createElement("g", { mask: "url(#mask0)" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3L7 5H9L8 3ZM8 12C9.65685 12 11 10.6569 11 9C11 7.34315 9.65685 6 8 6C6.34315 6 5 7.34315 5 9C5 10.6569 6.34315 12 8 12ZM12 8L14 9L12 10V8ZM2 9L4 10L4 8L2 9ZM10.1214 5.46445L12.2428 4.75734L11.5356 6.87866L10.1214 5.46445ZM3.7574 4.75737L4.46451 6.87869L5.87872 5.46448L3.7574 4.75737Z", fill: "#B5C2CA" })),
    react_1.default.createElement("rect", { x: "1", y: "11", width: "14", height: "1", fill: "#B5C2CA" })));
exports.TimeMorning = TimeMorning;
exports.default = exports.TimeMorning;
